import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Header from '../../components/Header';
import AccessibleChart from '../../components/AccessibleChart';
import Filters from '../../components/Filters';
import EulaAgreementModal from '../../components/EulaAgreementModal';
import { ventrisConfig } from '../../ventris.config';
import ResultsQuickActionIcon from '../../icons/ResultsQuickActionIcon';
import SchoolDirectoryQuickActionIcon from '../../icons/SchoolDirectoryQuickActionIcon';
import SlpDirectoryQuickActionIcon from '../../icons/SlpDirectoryQuickActionIcon';
import TeacherQuickActionIcon from '../../icons/TeacherQuickActionIcon';
import TestsQuickActionIcon from '../../icons/TestsQuickActionIcon';
import FilterIcon from '../../icons/FilterIcon';
import TestIcon from '../../icons/TestIcon';
import GroupIcon from '../../icons/GroupIcon';
import { getUseCaseTerminology } from '../../useCase';
import { userHasResultsAccess } from '../../assessmentAccess';

type AdminHomeProps = {
};

function AdminHome({}: AdminHomeProps) {
  const [tests, setTests] = useState([] as any);
  const [users, setUsers] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const terms = getUseCaseTerminology();
  const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10000);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [clinicianFilter, setClinicianFilter] = useState("");
  const [studentFilter, setStudentFilter] = useState("");
  const [testFilter, setTestFilter] = useState("");
  const [completionStatusFilter, setCompletionStatusFilter] = useState("");
  
  useEffect(() => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/users', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setUsers(data);
    });

    loadTests(1);
  }, []);

  useEffect(() => {
      loadTests(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, clinicianFilter, studentFilter, testFilter, completionStatusFilter]);

  const loadTests = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/tests?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&clinician=' + clinicianFilter + '&student=' + studentFilter + '&test=' + testFilter + '&completionStatus=' + completionStatusFilter + '&summary=true', {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setTests(data.tests);
      });
    },
    100);
  }

  const getTestData = () => {
    let testData: any = [];

    for (let i = 0; i < tests.length; i++) {
      var t = tests[i].created_at.replace("T", " ").replace("Z", " ").split(/[- :]/);
      var d = Date.UTC(t[0], t[1]-1, 1, 0, 0, 0);
      let found = false;

      for (let j = 0; j < testData.length; j++) {
        if (testData[j][0] == d) {
          testData[j][1]++;
          found = true;
          break;
        }
      }

      if (!found) {
        testData.push([d, 1]);
      }
    }

    return testData;
  }

  const chart1 = {
    chart: {
      type: 'spline',
      height: 330,
      backgroundColor: 'transparent'
    },
    title: {
      text: undefined
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      spline: {
        marker: {
          radius: 4,
          lineColor: '#562c83',
          fillColor: '#562c83',
          lineWidth: 1
        },
        color: '#562c83'
      }
    },
    series: [
      {
        name: 'Tests administered',
        data: getTestData()
      }
    ],
    xAxis: {
      type: 'datetime',
      title: { text: 'Month' },
      dateTimeLabelFormats: {
        day: '%m/%Y'
      }
    },
    yAxis: { title: { text: 'Tests administered' }, min: 0 }
  };

  const getUserData = () => {
    let userData: any = [];

    for (let i = 0; i < users.length; i++) {
      var t = users[i].created_at.replace("T", " ").replace("Z", " ").split(/[- :]/);
      var d = Date.UTC(t[0], t[1]-1, 1, 0, 0, 0);
      let found = false;

      for (let j = 0; j < userData.length; j++) {
        if (userData[j][0] == d) {
          userData[j][1]++;
          found = true;
          break;
        }
      }

      if (!found) {
        userData.push([d, 1]);
      }
    }

    return userData;
  }

  const chart2 = {
    chart: {
      type: 'spline',
      height: 330,
      backgroundColor: 'transparent'
    },
    title: {
      text: undefined
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      spline: {
        marker: {
          radius: 4,
          lineColor: '#562c83',
          fillColor: '#562c83',
          lineWidth: 1
        },
        color: '#562c83'
      }
    },
    series: [
      {
        name: `New ${terms.managedUsers.toLowerCase()} added`,
        data: getUserData()
      }
    ],
    xAxis: {
      type: 'datetime',
      title: { text: 'Month' },
      dateTimeLabelFormats: {
        day: '%m/%Y'
      }
    },
    yAxis: { title: { text: `New ${terms.managedUsers.toLowerCase()} added` }, min: 0 }
  };

  const updateFilters = (organizations: any, clinician: string, student: string, test: string, status: string, subtest: string, norms: string) => {
    setOrganizationFilter(organizations);
    setClinicianFilter(clinician);
    setStudentFilter(student);
    setTestFilter(test);
    setCompletionStatusFilter(status);
    setPage(1);
  };
  
  return (
    <Container fluid className="ventris-content-wrapper admin-dashboard">
      <Header portal="admin" page="home" />
      <Container as="main" id="main-content" tabIndex={-1} className="admin-dashboard-container">
        <Row>
          <Col>
            <section className="admin-dashboard-welcome">
              <h1>Welcome, {currentUser.first_name || "Admin"}!</h1>
              <p>Use the top navigation bar to explore the directory, {terms.students.toLowerCase()}, {terms.classes.toLowerCase()}, and tests or edit your profile. Or, select a quick action below:</p>
            </section>

            <section className="admin-dashboard-section">
              <h2>Quick Actions</h2>
              <div className="admin-quick-actions">
                <div className="admin-quick-action admin-quick-action-directory">
                  <div className="admin-quick-action-visual admin-quick-action-icon">
                    {terms.useCase === "SLP" ? <SlpDirectoryQuickActionIcon /> : <SchoolDirectoryQuickActionIcon />}
                  </div>
                  <div className="admin-quick-action-footer">
                    <Button onClick={() => document.location.href = "/organizations"}>View &amp; Manage {terms.directory}</Button>
                  </div>
                </div>
                <div className="admin-quick-action admin-quick-action-teachers">
                  <div className="admin-quick-action-visual admin-quick-action-icon"><TeacherQuickActionIcon /></div>
                  <div className="admin-quick-action-footer">
                    <Button onClick={() => document.location.href = "/users"}>View &amp; Manage {terms.managedUsers}</Button>
                  </div>
                </div>
                <div className="admin-quick-action admin-quick-action-tests">
                  <div className="admin-quick-action-visual admin-quick-action-icon"><TestsQuickActionIcon /></div>
                  <div className="admin-quick-action-footer">
                    <Button onClick={() => document.location.href = "/tests"}>Review Tests</Button>
                  </div>
                </div>
                {userHasResultsAccess(currentUser) ? <div className="admin-quick-action admin-quick-action-results">
                  <div className="admin-quick-action-visual admin-quick-action-icon"><ResultsQuickActionIcon /></div>
                  <div className="admin-quick-action-footer">
                    <Button onClick={() => document.location.href = "/results"}>View Results</Button>
                  </div>
                </div> : null}
              </div>
            </section>

            <section className="admin-dashboard-section admin-analytics-section">
              <h2>Test Analytics</h2>
              {showFilters ? <Filters updateFilters={updateFilters} hideFilters={['Subtest', 'Norms']} /> : null}
              <div className="admin-analytics-grid">
                <div className="admin-analytics-card">
                  <div className="admin-analytics-card-header">
                    <h3><TestIcon /> Test Volume</h3>
                    <Button variant="link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> Filter</Button>
                  </div>
                  <div className="analytics-chart">
                    <AccessibleChart
                      options={chart1}
                      title="Test volume"
                      description="The number of tests administered in each month for the selected filters."
                    />
                  </div>
                </div>
                <div className="admin-analytics-card">
                  <div className="admin-analytics-card-header">
                    <h3><GroupIcon /> New {terms.managedUsers} Added</h3>
                    <Button variant="link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> Filter</Button>
                  </div>
                  <div className="analytics-chart">
                    <AccessibleChart
                      options={chart2}
                      title={`New ${terms.managedUsers.toLowerCase()} added`}
                      description={`The number of new ${terms.managedUsers.toLowerCase()} added in each month.`}
                    />
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
      <EulaAgreementModal user={currentUser} />
    </Container>
  );
}

export default AdminHome;
